<template>
	<Card>
		<div class="multiple" style="margin-bottom: 20px;">
			<div class="child-div">时间区间</div>
			<RadioGroup v-model="timePeriod" @on-change="searchMyTask">
				<Radio label="0"><span>不限</span></Radio>
				<Radio label="1"><span>今日</span></Radio>
				<Radio label="2"><span>昨日</span></Radio>
				<Radio label="3"><span>本周</span></Radio>
				<Radio label="4"><span>上周</span></Radio>
				<Radio label="5"><span>本月</span></Radio>
				<Radio label="6"><span>上月</span></Radio>
				<Radio label="7"><span>自定义</span></Radio>
				<DatePicker v-if="timePeriod == '7' " :value="timePeriodDate" @on-change="timePeriodDateChange"
					type="daterange" placeholder="选择日期" style="width: 200px"></DatePicker>
			</RadioGroup>
		</div>
		<div class="multiple" style="margin-bottom: 20px;">
			<div class="child-div">来访团队</div>
			<Select v-model="followDepartment" @on-change="searchMyTask" clearable style="width:150px;" placeholder="跟进团队">
				<Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}
				</Option>
			</Select>
			<Button style="margin-left: 20px;" type="primary" v-on:click="initTask()">重置</Button>
		</div>
		<Table :columns="columns" :data="myTaskList" size="small" ref="table" v-if="type == 1">
			<template slot-scope="{ index,row }" slot="num">
				<span  style="color:#63B3E6;cursor: pointer;" @click.stop="visitDataClick(row.get_uid,1)">{{row.num}}</span>
			</template>
		</Table>
		<Table :columns="teamColumns" :data="teamTaskList" size="small" ref="table" v-if="type == 2">
				<template slot-scope="{ index,row }" slot="num">
					<span  style="color:#63B3E6;cursor: pointer;" @click.stop="visitDataClick(row.department,2)">{{row.num}}</span>
				</template>
		</Table>
		<div class="pager1">
			<Page show-total :total="count" :page-size="20" :current="page" @on-change="changePage" size="small"
				show-elevator />
		</div>
		<Modal v-model="visitDataModal" width="1200" title="来访客户">
			<TodayCustomer :shop_id="shop_id" :follow_uid_props = "follow_uid" :department_id_props="department_id" :timePeriod_props="timePeriod" :timePeriodDate_props="timePeriodDate"></TodayCustomer> 
		</Modal>
	</Card>
</template>

<script>
	import {
		getH5Url,
		getVisitingReport,
		getTeamVisitingReport,
		getClient,
		sureChooseClient
	} from '@/api/task'
	import {
		getList
	} from '@/api/client'
	import {
		getUserList,
		getTeamList,
		getDepartmentList,
	} from '@/api/user'
	import {
		mapActions,
		mapGetters
	} from "vuex";
	import TodayCustomer from '../TodayCustomer.vue'
	import EditClue from '../../client/EditClue.vue';
	import Clipboard from 'clipboard';

	export default {
		name: "VisitingCustomerReport",
		components: {
			EditClue,
			TodayCustomer
		},
		props:['type','shop_id'],
		computed: {
			...mapGetters(['token']),
		},
		watch: {
			shop_id() {
				console.log(this.shop_id)
				this.getList();
			}
		},		
		mounted: function() {
			this.loadData();
			this.getList();
		},
		data() {
			return {
				editModalStyle: {
					'top': '7%',
					'background': '#f9fafc',
					'border-radius': '15px'
				},
				editDiv: false,
				editModal: false,
				visitDataModal:false,
				editClientId: 0,
				h5Url: '',
				count: 0,
				page: 1,
				taskTitle: '',
				myTaskList: [],
				teamTaskList:[],
				timePeriod: '1',
				timePeriodDate: [],
				clientList: [],
				department_id:'',
				follow_uid:'',
				registerId: 0,
				clientId: 0,
				chooseModal: false,
				columns: [{
                        type: 'index',
						title: '排名',
                        width: 60,
                        align: 'center'
                    },
					{
						title: '客户经理',
						align: 'center',
						key: 'userName',
					},
					{
						title: '所属部门',
						align: 'center',
						key: 'departmentName',
					},
					{
						title: '数量',
						align: 'center',
						slot: 'num',
					},
				],
				teamColumns: [{
                        type: 'index',
						itle: '排名',
                        width: 60,
                        align: 'center'
                    },
					{
						title: '部门',
						align: 'center',
						key: 'departmentName',
					},
					{
						title: '在职人数',
						align: 'center',
						key: 'user_num',
					},
					{
						title: '数量',
						align: 'center',
						slot: 'num',
					},
				],
				departmentList:[],
				followDepartment:'',
			}
		},
		methods: {
			...mapActions([
				'handleLogOut',
			]),
			searchMyTask() {
				this.page = 1;
				this.getList();
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			timePeriodDateChange(e) {
				this.timePeriodDate = e;
				this.searchMyTask();
			},
			async loadData() {
				let that = this;
				var data = {
					token: this.token
				};
				let res = await getH5Url(that, data);
				if (res.code == 1) {
					that.h5Url = res.data.h5Url;
				}
				res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
			},
			initTask(){
				this.timePeriodDate = [];
				this.timePeriod = '0';
				this.followDepartment = [];
				this.searchMyTask();
			},
			async getList() {
				let that = this;
				let data = {
					timePeriod: that.timePeriod,
					timePeriodDate: that.timePeriodDate
				}
				data.name = this.taskTitle;
				data.token = this.token;
				data.page = this.page;
				data.shop_id = this.shop_id;
				data.followDepartment = this.followDepartment;
				if(that.type == 1){
					let res = await getVisitingReport(that, data);
					that.myTaskList = res.data.list;
					that.count = res.count;
				}else{
					let res = await getTeamVisitingReport(that, data);
					that.teamTaskList = res.data.list;
					that.count = res.count;
				}
			},
			getClient(e) {
				let id = e.currentTarget.dataset.id;
				let clientId = e.currentTarget.dataset.client_id;
				let that = this;
				this.$Modal.confirm({
					title: '确认领取吗？',
					onOk: async () => {
						var data = {
							token: this.token,
							id: id,
							client_id: clientId
						};
						let res = await getClient(that, data);
						if (res.code == 1) {
							that.$Message.success(res.msg);
							that.getList();
						}
					}
				})

			},
			visitDataClick(type_id,type) {
				let that = this;
				if(type == 1){
					that.follow_uid = type_id;
				}else{
					that.department_id = type_id;
				}
				that.visitDataModal = true;
			},
			sureChoose() {
				let that = this;
				var data = {
					token: this.token,
					client_id: that.clientId,
					id: that.registerId
				};
				this.throttle(async function() {
					let res = await sureChooseClient(that, data);
					if (res.code == 1) {
						that.$Message.success(res.msg);
						that.chooseModal = false;
						that.getList();
					}
				}, 500)
			},
			async chooseClient(e) {
				let that = this;
				that.registerId = e.currentTarget.dataset.id;
				let data = {
					menu: 'my_undoor'
				}
				data.name = e.currentTarget.dataset.name;
				data.token = this.token;
				let res = await getList(that, data);
				that.clientList = res.data.list;
				this.chooseModal = true;
			},
			copyH5() {
				let that = this;
				var clipboard = new Clipboard('.copy_area')
				clipboard.on('success', e => {
					that.$Message.success("复制成功");
					clipboard.destroy()
				})
				clipboard.on('error', e => {
					that.$Message.error('该浏览器不支持自动复制')
					clipboard.destroy()
				})
			},
			addClient() {
				let that = this;
				this.clientId = 0;
				this.editDiv = true;
				this.$nextTick(function() {
					that.editModal = true;
				})
			},
			beforeEditOne() {
				let that = this;
				that.$Message.error('此页面不可使用此功能');
			},
			nextEditOne() {
				let that = this;
				that.$Message.error('此页面不可使用此功能');
			}
		},
		filters: {
			getPhoneNumber(phone) {
				const newPhone = phone.substring(0, 3) + '****' + phone.substring(7, 11)
				return newPhone
			},
		}
	}
</script>

<style scoped lang="less">
	.text-center {
		height: 580px;
		overflow: scroll;
	}

	.shijian {
		position: relative;
		left: 15px;
	}

	.xiaoxi {
		position: relative;
		left: -120px;
		top: 18px;
	}

	.icon-biao {
		display: flex;
		justify-content: left;
		font-size: 15px;
		margin-bottom: 30px;
	}

	.xiangqing {
		background-color: #F9FAFA;
	}

	.biaoti {
		font-weight: bold;
	}

	.biaogetoubu {
		background-color: #F9FAFA;
		border-bottom: 1px solid #E8EAEC;
	}

	.shuju {
		margin-bottom: 10px;
		text-align: left;
		text-align-last: justify;
		display: flex;
		justify-content: left;

		div {
			margin-right: 20px;
			width: 60px;
		}
	}

	.biaogelimian {
		display: flex;
		justify-content: space-around;
	}

	.shanchu {
		margin-right: 10px;
		color: #54A1F3;
		font-size: 15px;
	}

	.biaotou {
		display: flex;
		justify-content: space-between;
	}

	.xinjianbottom {
		margin-top: 60px;
		display: flex;
		justify-content: left;
	}



	.dialoglist {
		display: flex;
		justify-content: left;
		align-items: center;
		margin-bottom: 20px;
	}

	.assign {
		position: relative;
		left: 80%;
		top: -232px;
	}

	.top-add {
		position: relative;
		width: 30px;
		left: 80%;
		bottom: 30px;
	}

	.input-text {
		margin-top: 30px;
		display: flex;
		justify-content: left;
		align-items: center;

		div {
			margin: 0 10px;
		}
	}

	.top-save {
		position: relative;
		left: 70%;
		top: -30px;
	}

	.cascader {
		width: 380px;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;

		.child-div {
			width: 60px;
			height: 20px;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.chongzhi {
		position: absolute;
		top: 16px;
		left: 280px;
	}

	.sousuo {
		height: 32px;
		width: 100%;
		margin-bottom: 20px;
	}

	.ivu-table-fixed-header thead tr th {
		text-align: center;
	}

	.get_state {
		color: #2C8CF0;
	}

	.inline-block {
		display: inline-block;
	}
</style>
